
























import Vue, { PropType } from 'vue';
import moment from 'moment';
import { InstallationModule, MechanicInstallation, Nullable } from '@/types';

import Item from './Item.vue';

export default Vue.extend({
  props: {
    installations: {
      type: Array as PropType<MechanicInstallation[]>,
      default: () => [],
    },
    loading: Boolean,
  },

  components: {
    InstallationItem: Item,
  },
});
